import React, { useEffect, useRef, useState } from "react";
import { OpenContentButton } from "@/components/ui-kit/Buttons/OpenContentButton";
import { InfoBoxProps } from "@/types/modules/post/contentComponents";
import { useParsedContent } from "@/hooks/useParsedContent";
import styles from "@/styles/post.module.css";
import Image from "next/image";
import autoAnimate from "@formkit/auto-animate";

export const InfoBox: React.FC<InfoBoxProps> = ({
  title,
  subtitle,
  content,
  photo,
  photoTitle,
  contentCollapse,
  photoAuthor,
  source,
}) => {
  const [fullPostVisibility, setFullPostVisibility] = useState(!contentCollapse);
  const [parsedContent] = useParsedContent(content, false);

  const parent = useRef(null);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, [parent]);

  return (
    <div className="mx-6 mb-6 max-w-[400px] pb-4 font-sans md:mx-auto">
      {photo && <Image src={photo} alt={photoTitle || ""} width={400} height={252} />}
      <div className="flex flex-col">
        {photoTitle && (
          <span className="mt-[9px] inline-flex !px-0 font-sans text-2xs text-dark-70 dark:text-white sm:text-md">
            {photoTitle}
          </span>
        )}
        {source && <span className="mt-[9px] inline-flex text-3xs text-dark-70">{source}</span>}
      </div>

      <h2 className="my-4 border-b-2 border-turquoise pb-2 font-condensed text-3xl font-light text-turquoise dark:border-light-turquoise dark:text-light-turquoise sm:text-5xl">
        {title}
      </h2>
      <h5 className="mb-4 font-condensed text-base uppercase text-dark-70 dark:text-white-70 sm:text-xl">{subtitle}</h5>
      <div ref={parent} className={fullPostVisibility ? "" : "dela relative max-h-[300px] overflow-hidden"}>
        {contentCollapse && !fullPostVisibility && <div className={styles.infoBoxOverlay}></div>}
        <div className={styles.infoBoxContent}>{parsedContent}</div>
      </div>
      {contentCollapse && (
        <OpenContentButton
          title={!fullPostVisibility ? "Celý sloupek" : "Zavřít"}
          styles={
            fullPostVisibility
              ? "absolute left-5 transition ease-in-out delay-100 rotate-180"
              : "absolute left-5 transition ease-in-out delay-100"
          }
          onClick={() => setFullPostVisibility(!fullPostVisibility)}
        />
      )}
    </div>
  );
};
